"use client";
import {
  DialogContextProvider
} from "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HKOOKEDE.js";
import {
  useDialogStore
} from "../__chunks/QYS5FHDY.js";
import "../__chunks/KGK2TTFO.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/dialog/dialog-provider.tsx
import { jsx } from "react/jsx-runtime";
function DialogProvider(props = {}) {
  const store = useDialogStore(props);
  return /* @__PURE__ */ jsx(DialogContextProvider, { value: store, children: props.children });
}
export {
  DialogProvider
};
